"use client";

import Link from "next/link";
import { useCheckoutCart } from "./useCheckoutCart";

export function AddToCartButton({
  moduleId,
  label = "Add to cart",
}: {
  moduleId: string;
  label?: string;
}) {
  const { addModule, cart } = useCheckoutCart();
  const inCart = cart.moduleIds.includes(moduleId);

  if (inCart) {
    return (
      <Link href="/checkout" className="btn btn-primary">
        In cart · Checkout
      </Link>
    );
  }

  return (
    <button
      type="button"
      className="btn btn-ghost"
      onClick={() => addModule(moduleId)}
    >
      {label}
    </button>
  );
}

export function CartLink() {
  const { itemCount, ready } = useCheckoutCart();
  // Always render the same chrome slot — returning null until ready shifted the sticky nav (CLS ~0.07).
  return (
    <Link href="/checkout" className="checkout-cart-link">
      Cart{ready && itemCount > 0 ? ` (${itemCount})` : ""}
    </Link>
  );
}
